import React from "react";
import HeroImg from "../../assets/blog.webp";

const Hero = () => {
  return (
    <div className="relative w-full h-screen  flex items-center justify-center">
      <div className=" mx-auto grid md:grid-cols-2 gap-8 items-center">
        {/* Left Content */}
        <div className="text-white">
          <p className="text-sm uppercase tracking-wide text-gray-300">
            Featured story
          </p>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mt-4 mb-8">
            Ten principles of Multify: <br /> How to keep your focus in a
            dynamic environment?
          </h1>
          <p className="text-gray-300 mt-4 text-sm md:text-base mb-4">
            People often see multitasking as a crucial skill at work. In
            reality, you can only be in one place and do one thing at a time,
            while working with different ideas, tasks, and projects.
          </p>
          <button className="mt-6 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-[50px] transition-all border-1 gradient-border">
            Read More
          </button>
        </div>

        {/* Right Image */}
        <div className="flex justify-center">
          <img
            src={HeroImg}
            alt="Hero"
            className="w-full max-w-md md:max-w-lg lg:max-w-xl"
          />
        </div>
      </div>
    </div>
  );
};

export default Hero;
